var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGoogle = function SvgGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M15.635 8.177c0-.656-.053-1.134-.168-1.63h-7.49v2.96h4.396c-.088.736-.567 1.843-1.63 2.588l-.015.099 2.368 1.834.164.017c1.507-1.392 2.375-3.44 2.375-5.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M7.977 15.977c2.154 0 3.962-.709 5.283-1.932l-2.518-1.95c-.673.47-1.577.798-2.765.798-2.11 0-3.9-1.392-4.538-3.315l-.094.008L.883 11.49l-.032.09a7.971 7.971 0 0 0 7.126 4.396Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M3.439 9.578A4.911 4.911 0 0 1 3.173 8c0-.55.098-1.081.257-1.578l-.004-.105L.932 4.38l-.081.04A7.985 7.985 0 0 0 0 8c0 1.285.31 2.5.85 3.58L3.44 9.579Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M7.977 3.107c1.498 0 2.508.647 3.085 1.188l2.25-2.198C11.93.812 10.132.023 7.978.023A7.971 7.971 0 0 0 .851 4.419l2.58 2.003C4.076 4.5 5.867 3.107 7.976 3.107Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;